import DataStore from '@/app-core/lib/data/dataStore/DataStore'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import dayjs from 'dayjs'
import 'dayjs/locale/el'
import 'dayjs/locale/en'

import core_el from '@/theme/default/lang/locale/el/Index.js'
import core_en from '@/theme/default/lang/locale/en/Index.js'
import theme_el from '@/app-theme/lang/locale/el/Index.js'
import theme_en from '@/app-theme/lang/locale/en/Index.js'

Vue.use(VueI18n)

export const languages = [
  {
    active    : false,
    visible   : false,
    default   : false,
    name      : 'Ελληνικά',
    short_name: 'GR',
    locale    : 'el',
    code      : 'el-GR',
    code2     : 'el_GR',
    icon      : '/img/flags/1x1/gr.svg'
  },
  {
    active    : false,
    visible   : false,
    default   : false,
    name      : 'English',
    short_name: 'EN',
    locale    : 'en',
    code      : 'en-US',
    code2     : 'en_US',
    icon      : '/img/flags/1x1/gb.svg'
  }
]


const messages = {
  el: {...core_el, ...theme_el}, //mergeDeep(core_el, theme_el),
  en: {...core_en, ...theme_en}
}

export const i18n = new VueI18n({
  locale               : import.meta.env.VITE_I18N_LOCALE || 'el',
  defaultLocale        : import.meta.env.VITE_I18N_LOCALE || 'el',
  fallbackLocale       : import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: import.meta.env.MODE === 'production',
  messages
})
i18n.languages = languages

export const initI18nLanguages = () => {
  for (let i = 0; i < languages.length; i++) {
    const lang = languages[i]

    lang.default = false
    lang.active = false
    lang.visible = false

    if (lang.locale === DataStore?.App?.Config?.Marketplace?.DefaultLocale) {
      i18n.locale = lang.locale
      i18n.defaultLocale = lang.locale
      lang.default = true
    }
    if (DataStore?.App?.Config?.Marketplace?.ActiveLocales?.includes(lang.locale)) {
      lang.active = true
      lang.visible = true
    }
  }

  i18n.languages = languages
}

export const getI18nDefaultLanguage = () => {
  return languages?.find(l => l.default) || languages[0]
}

export const setI18nLanguage = (locale) => {
  const lang = languages.find(l => l.locale === locale) || getI18nDefaultLanguage()

  i18n.locale = lang.locale
  i18n.code = lang.code
  i18n.code2 = lang.code2
  i18n.name = lang.name
  i18n.short_name = lang.short_name
  i18n.active = lang.active
  if (dayjs) dayjs.locale(lang.locale)
  if (window.Vue) window.Vue.$vuetify.lang.current = lang.locale
  document.querySelector('html').setAttribute('lang', lang.locale)
  return lang
}

export default i18n
